export function buildChannel(feature, scope, id) {
  return `${feature}/${scope}/${id}`;
}
